export const TERMS_DATA = [
    {
        title: "Services",
        sections: [
            { title: "Money Rate Finder provides tax calculation tools and financial insights. The app does not offer financial or legal advice."},
            // { title: "By accessing or using our Website, submitting any data, or using our services, you agree to comply with these Terms. If you do not agree, you must not use our Website.", list: [] },
            // { title: "You must be at least 18 years of age to use our Website. By agreeing to these Terms, you confirm that you meet this requirement.", list: [] },
            // { title: "Our Website uses cookies. By using our Website, you consent to our cookie policy as outlined in our Privacy Policy.", list: [] },
        ],
    },
    {
        title: "User Responsibilities",
        sections: [
            { title:  <>
                <ul className="list-disc list-inside">
                    <li>Users must provide accurate information.</li>
                    <li>Unauthorized use of the app is prohibited.</li>
                    <li>Users are responsible for their own financial decisions.</li>
                </ul>
                </>},
            // {
            //     title: " Subject to the limited rights expressly granted under these Terms: ",
            //     list: ["We own and control all intellectual property rights in our Website and its content.", "No part of our Website may be copied, reproduced, or distributed without our permission."]
            // },
        ],
    },
    {
        title: "Privacy & Data Use",
        sections: [
            { title: "We respect user privacy and we do not collect any data on moneyratefinder. No Data is shared with third parties."},
            // {
            //     title: "You must not:", list: ["Republish, redistribute, sell, or exploit any material from our Website.", "Use our Website for unlawful activities.", "Modify or interfere with Website functionality."]
            // },
        ],
    },
    {
        title: "Liability Disclaimer",
        sections: [
            {
                title: "Money Rate Finder provides services “as-is.” We are not responsible for financial losses, app downtime, or errors in calculations."
            },
            // { title: " You agree that all information you provide is accurate, current, and complete.", list: [] },
        ],
    },
    {
        title: "Updates & Changes",
        sections: [
            { title: "These terms may be updated from time to time. Continued app use constitutes acceptance of updates."},
            // { title: "We do not endorse or guarantee the accuracy, availability, or security of any third-party services listed.", list: [] },
            // {
            //     title: " You acknowledge that:", list: ["We do not verify provider credentials.", "We are not responsible for transactions made with third-party providers.", "Any financial decision you make is at your own risk."]
            // },
        ],
    },
    // {
    //     title: "Third-Party Websites",
    //     sections: [
    //         {
    //             title: "Our Website contains links to third-party websites. These are provided for convenience, and we are not responsible for their content or security.", list: []
    //         },
    //     ],
    // },
    // {
    //     title: "Limitation of Liability",
    //     sections: [
    //         {
    //             title: ` We provide our services " as is" without warranties of any kind. To the maximum extent permitted by law, we exclude:`, list: ["Liability for inaccuracies in third-party exchange rates or fees.", "Responsibility for financial losses arising from remittance provider transactions.", "Liability for any service interruptions, data loss, or security breaches."]
    //         },
    //     ],
    // },
    // {
    //     title: "Indemnification",
    //     sections: [
    //         { title: "You agree to indemnify and hold us harmless from claims, damages, and expenses arising from your misuse of our Website or breach of these Terms.", list: [] },
    //     ],
    // },
    // {
    //     title: "Amendments",
    //     sections: [
    //         {
    //             title: " We may update these Terms from time to time. Continued use of our Website after updates constitutes acceptance of the revised Terms.", list: []
    //         },
    //     ],
    // },
    // {
    //     title: "Governing Law and Jurisdiction",
    //     sections: [
    //         { title: " These terms and conditions shall be governed by and construed in accordance with Indian law.", list: [] },
    //         { title: "Any disputes arising from these terms shall be subject to the exclusive jurisdiction of the courts of India.", list: [] }
    //     ],
    // },
    // {
    //     "title": "Contact Information",
    //     "sections": [
    //         {
    //             "title": "This website is owned and operated by Money Rate Finder.",
    //             "list": []
    //         },
    //         {
    //             "title": "Our registered office is located at: C 133, Chattarpur Enclave, Phase 2, New Delhi - 110074",
    //             "list": []
    //         },
    //         {
    //             "title": <>
    //             `You can contact us: (a) By email: <a href="mailto:Product@upgrowthmarketing.in">Product@upgrowthmarketing.in</a> (b) Through our website contact form.`
    //             </>,
    //             "list": []
    //         }
    //     ]
    // }
]
